export const initialNextOrderStateLabelDefault = {
    27: 'Start Preparation',
    28: 'Preparation Completed',
    29: 'Lab Assigned',
    30: 'Chemist Assigned',
    31: 'Chemist On His Way',
    32: 'Ready To Collect',
    33: 'Sample Collected',
    34: 'Sample Dropped',
    35: 'Results Sent',
  };

  export const initialNextOrderStateDefault = {
    27: 28,
    28: 29,
    29: 30,
    30: 31,
    31: 32,
    32: 33,
    33: 34,
    34: 35,
    35: 36,
  };
